import Styles from './styles.module.css';
import React, { useState } from 'react';
import { targetData } from 'src/type';
import { useNavigate } from 'react-router-dom';

// 求人票の年度別編集画面(2.jobPostings/edit)専用の確認モーダル。
// 1.manual/3.school/confirm/index.tsx を元にしているが、オンボーディング専用の
// companies/{id}.progress.jobPostings への書き込みと
// /service/manual/sending への遷移は行わず、年度一覧(/service/jobPostings)に
// 戻るだけにしている。

type SchoolUnPublic = {
  companyId: string;
  year: string;
  target: targetData;
  setConfirm: React.Dispatch<React.SetStateAction<boolean>>;
};

const SchoolUnPublic: React.FC<SchoolUnPublic> = ({ companyId, year, target, setConfirm }) => {

  const navigate = useNavigate();

  const [ uploading, setUploading ] = useState(false);

  const unPublic = async () => {
    setUploading(true);

    try {
      navigate("/service/jobPostings");

    } catch (error) {
      console.error("unPublic failed:", error);

    } finally {
      setUploading(false);
    }
  };

  const documentLabel = `${companyId}_${year}`;

  return (
    <>
    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}

    <div className={Styles.modal_contents}>
      <h4>求人票の内容確認</h4>
      <p className={Styles.modal_contents_p}>ご作成いただきました求人票を元に、各学校様への発送を行う仕組みでございますので、求人票の内容については必ずご確認くださいませ。</p>
      <p className={Styles.modal_contents_p}>※年間の発送は1回/1社様となっておりますので、求人票の内容を変更する等のサービスはございませんので、予めご理解ください。</p>
      <div>
        <button style={{backgroundColor : 'white', color : '#1B1B1B'}} onClick={() => setConfirm(false)}>戻る</button>
        <button style={{backgroundColor : '#1B1B1B', color : 'white'}} onClick={() => unPublic()}>確定</button>
      </div>
      {target.target.includes("専門(20歳卒)") && (
        <a href={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/jobPostingsPdf%2F${documentLabel}_20.pdf?alt=media&token=`} target="_blank" rel="noopener noreferrer">
          <p className={Styles.check}>求人票（20歳卒）を確認する</p>
        </a>
      )}
      {target.target.includes("高専(18歳卒)") && (
        <a href={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/jobPostingsPdf%2F${documentLabel}_18.pdf?alt=media&token=`} target="_blank" rel="noopener noreferrer">
          <p className={Styles.check}>求人票（18歳卒）を確認する</p>
        </a>
      )}
      {target.target.includes("高専(17歳卒)") && (
        <a href={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/jobPostingsPdf%2F${documentLabel}_17.pdf?alt=media&token=`} target="_blank" rel="noopener noreferrer">
          <p className={Styles.check}>求人票（17歳卒）を確認する</p>
        </a>
      )}
    </div>
    </>
  );
}

export default SchoolUnPublic;
